import { Component, OnInit } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { CommonService } from 'src/services/common/common.service';

@Component({
  selector: 'app-change-language',
  templateUrl: './change-language.component.html',
  styleUrls: ['./change-language.component.scss']
})
export class ChangeLanguageComponent implements OnInit {

  language: any;

  constructor(public commonService: CommonService, 
    private translate: TranslateService) { 
      this.language = localStorage.getItem("language") || "en"
    }

  ngOnInit(): void {}
    /**
     * Sets language
     * @param lang 
     */
    setLanguage(lang: any){
      this.language = lang
    }
}
